import { render, staticRenderFns } from "./SignupVendor.vue?vue&type=template&id=62be3ca3&scoped=true&"
import script from "./SignupVendor.vue?vue&type=script&lang=js&"
export * from "./SignupVendor.vue?vue&type=script&lang=js&"
import style0 from "./SignupVendor.vue?vue&type=style&index=0&id=62be3ca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be3ca3",
  null
  
)

export default component.exports